
<template>
    <div>
        <div class="d-flex flex-column align-items-center">
            <!-- Common main element parameters-->
            <div
                v-if="!prop_readonly && helper.isTramoComun()"
                class="text-left"
                :class="[
                    helper.isFloor() && isMobile ? 'mb-3' : '',
                    helper.isWall() ? 'mb-3' : '',
                    helper.withSoportajeCliente() ? 'mb-5' : '',
                    helper.isCeiling() && isMobile && ! helper.withSoporteTrapecio() ? 'mb-3' : '',
                    helper.isCeiling() && isMobile &&  helper.withSoporteTrapecio() ? 'mb-5' : '',
                ]"
            >
                <div
                    v-for="parameter in app.currentConfiguration
                        .commonMainElementParameters"
                    style="
                        border: 0px solid black;
                        background-color: white;
                        position: relative;
                    "
                    :key="parameter.attribute.id"
                    class="my-1 d-flex flex-row"
                >
                    <editParameterValueComponent
                        ref="editParameterValueComponent"
                        :labelOverInput="isMobile ? true : false"
                        :parameter="parameter"
                        :prop_title_show="true"
                        :value.sync="parameter.value"
                        :html_tooltip_info_dist_max_bandeja="
                            parameter.attribute.id === 'distancia_soportes'
                                ? true
                                : false
                        "
                        :style_inside_dropdown="
                            'left:100px; padding:4px !important; width: ' +
                            width_params
                        "
                        :style_inside_textbox="'width:' + width_params"
                        @update:value="refreshParameters"
                        @beforeUpdate:value="beforeUpdateParameter"
                        @afterUpdate:value="afterUpdateParameter"
                        v-if="helper.showCommonParameter(parameter)"
                    ></editParameterValueComponent>
                </div>

                <!-- distance info mesage -->
                <div
                    class="alert"
                    v-if="!helper.isDistanceOk()"
                    :class="'alert-danger'"
                    role="alert"
                >
                    <p v-html="helper.getDistanceMessage()"></p>
                </div>
            </div>

            <!-- Iterate mainElements -->
            <div class="d-flex flex-row d-flex flex-column align-items-center">
                <div
                    class="d-flex"
                    :class="[
                        direccionHorizontal && helper.isTramoComun()
                            ? 'flex-row justify-content-center'
                            : 'flex-column align-items-center',
                    ]"
                    style="position: relative; width: 100%"
                >
                    <div
                        v-for="(mainElementParameters, key, index) in this.app
                            .currentConfiguration.mainElementParameters"
                        :key="key"
                    >
                        <div
                            class="d-flex flex-row"
                            :class="{
                                'mb-5': helper.isTramosDistintos(),
                            }"
                            :style="'position: relative'"
                        >
                            <!-- ------ -->
                            <!-- IMAGES -->
                            <!-- ------ -->
                            <div
                                :style="
                                    'position: relative; height: ' +
                                    imgSize +
                                    'px; width:' +
                                    imgSize +
                                    'px;'
                                "
                                :class="[
                                    prop_readonly
                                        ? 'z_index_readonly'
                                        : 'z_index_no_readonly',
                                    app.currentConfiguration.stage === 4
                                        ? 'image_cursor_pointer'
                                        : 'image_cursor_default',
                                ]"
                                :ref="'div_imgs_numbandeja_' + key"
                                @click="scrollToElement('id_' + key)"
                            >
                                <!-- wall - ceiling - floor -->
                                <img
                                    v-if="
                                        (helper.isWall() ||
                                            (helper.isCeiling() && index === 0) ||
                                            helper.isFloor()) &&
                                        !helper.withSoportajeCliente()
                                    "
                                    :src="
                                        require('@/assets/images/gamas/67/pared.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:' +
                                        topPositionTerra +
                                        'px' +
                                        '; left: ' +
                                        leftPositionTerra +
                                        'px; transform: rotate(' +
                                        rotacioTerra +
                                        'deg)'
                                    "
                                    :id="'img_wall_on_' + key"
                                    :ref="'img_wall_on_' + key"
                                    class="simetrica"
                                />
                                <!-- bandeja -->
                                <img
                                    :src="
                                        require('@/assets/images/gamas/67/bandeja.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:' +
                                        topPositionBandejaTapaTabiques +
                                        'px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;' +
                                        'transform: rotate(' +
                                        rotacioBandeja +
                                        'deg)'
                                    "
                                    :id="'img_bandeja_numbandeja_' + key"
                                    :ref="'img_bandeja_numbandeja_' + key"
                                    class="simetrica"
                                />
                                <!-- soporte horizontal directo pared -->
                                <img
                                    v-if="helper.withSoporteHorizontalDirectoPared()"
                                    :src="
                                        require('@/assets/images/gamas/67/soporte_horizontal_directo_pared.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:0px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;' +
                                        'transform: rotate(' +
                                        rotacioBandeja +
                                        'deg)'
                                    "
                                    :id="'img_bandeja_numbandeja_' + key"
                                    :ref="'img_bandeja_numbandeja_' + key"
                                    class="simetrica"
                                />
                                <!-- soporte horizontal -->
                                <img
                                    v-if="helper.withSoporteHorizontal()"
                                    :src="
                                        require('@/assets/images/gamas/67/soporte_horizontal.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:0px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;' +
                                        'transform: rotate(' +
                                        rotacioBandeja +
                                        'deg)'
                                    "
                                    :id="'img_bandeja_numbandeja_' + key"
                                    :ref="'img_bandeja_numbandeja_' + key"
                                    class="simetrica"
                                />
                                <!-- perfil con conector suelo -->
                                <img
                                    v-if="
                                        helper.withPerfil() &&
                                        helper.isWall() &&
                                        growUp &&
                                        index === 0 &&
                                        !helper.withPerfilDirectoAPared()
                                    "
                                    :src="
                                        require('@/assets/images/gamas/67/perfil_con_conector_suelo.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:0px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;' +
                                        'transform: rotate(' +
                                        rotacioBandeja +
                                        'deg)'
                                    "
                                    :id="'img_bandeja_numbandeja_' + key"
                                    :ref="'img_bandeja_numbandeja_' + key"
                                    class="simetrica"
                                />
                                <!-- perfil con conector techo -->
                                <img
                                    v-if="
                                        helper.withPerfil() &&
                                        growDown &&
                                        index === 0 &&
                                        !helper.withPerfilDirectoAPared()
                                    "
                                    :src="
                                        require('@/assets/images/gamas/67/perfil_con_conector_techo.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:0px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;' +
                                        'transform: rotate(' +
                                        rotacioBandeja +
                                        'deg)'
                                    "
                                    :id="'img_bandeja_numbandeja_' + key"
                                    :ref="'img_bandeja_numbandeja_' + key"
                                    class="simetrica"
                                />
                                <!-- perfil directo pared o multinivel perfil-->
                                <img
                                    v-if="
                                        helper.withPerfilDirectoAPared() ||
                                        (helper.isCeiling() && index !== 0 && helper.withPerfil())
                                    "
                                    :src="
                                        require('@/assets/images/gamas/67/perfil_pared.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:0px;' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;' +
                                        'transform: rotate(' +
                                        rotacioBandeja +
                                        'deg)'
                                    "
                                    :id="'img_bandeja_numbandeja_' + key"
                                    :ref="'img_bandeja_numbandeja_' + key"
                                    class="simetrica"
                                />

                                <!-- soporte separador -->
                                <img
                                    v-if="helper.withSoporteSeparador()"
                                    :src="
                                        require('@/assets/images/gamas/67/separador_suelo.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:' +
                                        topPositionBandejaTapaTabiques +
                                        'px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;'
                                    "
                                    :id="'img_bandeja_numbandeja_' + key"
                                    :ref="'img_bandeja_numbandeja_' + key"
                                    class="simetrica"
                                />
                                <!-- soporte trapecio -->
                                <img
                                    v-if=" helper.withSoporteTrapecio()"
                                    :src="
                                        require('@/assets/images/gamas/67/trapezio.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:' +
                                        topPositionTrapecio +
                                        'px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;'
                                    "
                                    :id="'img_bandeja_numbandeja_' + key"
                                    :ref="'img_bandeja_numbandeja_' + key"
                                    class="simetrica"
                                />
                                <!-- tapa inferior -->
                                <img
                                    v-if="mostrarTapa_inferior"
                                    v-show="
                                        mostrarTapa_inferior(
                                            mainElementParameters
                                        )
                                    "
                                    :src="
                                        require('@/assets/images/gamas/67/tapa_inferior.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:' +
                                        topPositionBandejaTapaTabiques +
                                        'px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;' +
                                        'transform: rotate(' +
                                        rotacioBandeja +
                                        'deg)'
                                    "
                                    :id="'img_tapa_numbandeja_' + key"
                                    :ref="'img_tapa_numbandeja_' + key"
                                    class="simetrica"
                                />

                                <!-- tapa superior -->
                                <img
                                    v-if="mostrarTapa_superior"
                                    v-show="
                                        mostrarTapa_superior(
                                            mainElementParameters
                                        )
                                    "
                                    :src="
                                        require('@/assets/images/gamas/67/tapa_superior.png')
                                    "
                                    alt
                                    :style="
                                        'height: ' +
                                        imgSize +
                                        'px; width: ' +
                                        imgSize +
                                        'px; position: absolute; top:' +
                                        topPositionBandejaTapaTabiques +
                                        'px; ' +
                                        'left: ' +
                                        leftPositionImageRight +
                                        'px;' +
                                        'transform: rotate(' +
                                        rotacioBandeja +
                                        'deg)'
                                    "
                                    :id="'img_tapa_numbandeja_' + key"
                                    :ref="'img_tapa_numbandeja_' + key"
                                    class="simetrica"
                                />

                                <!-- parametres dimensiones -->
                                <div v-if="prop_readonly || isMobile">
                                    <div
                                        class="text-left textParamFontSize"
                                        :style="
                                            'top: ' +
                                            topPositionTextDimension +
                                            'px; ' +
                                            'left: ' +
                                            leftPositionTextDimension +
                                            'px;'
                                        "
                                        style="position: absolute; width: 100px"
                                    >
                                        {{
                                            app.currentConfiguration
                                                .mainElementParameters[key]
                                                .dimensiones.valueString
                                        }}
                                    </div>
                                </div>
                            </div>

                            <!-- ------ -->
                            <!-- PARAMS -->
                            <!-- ------ -->
                            <div
                                v-if="!prop_readonly && !isMobile"
                                :style="'position: relative;'"
                                class="
                                    d-flex
                                    flex-column
                                    justify-content-center
                                    align-items-start
                                    pos_params_vert
                                "
                                :class="{
                                    'ml-2': isMobile,
                                    'ml-4': helper.isFloor() && growDown,
                                    'small-text': helper.isTramosDistintos(),
                                }"
                            >
                                <!-- PARAMETROS TRAMOS DIFERENTES -->
                                <editParameterValueComponent
                                    v-if="helper.isTramosDistintos()"
                                    ref="editParameterValueComponent"
                                    :mainElement="mainElementParameters"
                                    :parameter="
                                        mainElementParameters[
                                            'metros_por_tramo'
                                        ]
                                    "
                                    :value.sync="
                                        mainElementParameters[
                                            'metros_por_tramo'
                                        ].value
                                    "
                                    :no_margin_padding_titel="
                                        isMobile && direccionVertical
                                            ? true
                                            : false
                                    "
                                    :placeholder_titel="
                                        mainElementParameters[
                                            'metros_por_tramo'
                                        ].attribute.name
                                    "
                                    :style_edit_param="
                                        'margin-top: ' +
                                        margin_dropdowns +
                                        'px ;margin-bottom: ' +
                                        margin_dropdowns +
                                        'px;'
                                    "
                                    :style_inside_dropdown="
                                        'padding:4px !important; width: ' +
                                        width_params
                                    "
                                    :labelOverInput="true"
                                    :prop_title_show="true"
                                    @update:value="refreshParameters"
                                    @beforeUpdate:value="beforeUpdateParameter"
                                    @afterUpdate:value="afterUpdateParameter"
                                ></editParameterValueComponent>
                                <editParameterValueComponent
                                    ref="editParameterValueComponent"
                                    v-if="helper.isTramosDistintos() && helper.mustShowDistanciaEntreSoportes()"
                                    :mainElement="mainElementParameters"
                                    :parameter="
                                        mainElementParameters[
                                            'distancia_soportes'
                                        ]
                                    "
                                    :value.sync="
                                        mainElementParameters[
                                            'distancia_soportes'
                                        ].value
                                    "
                                    :no_margin_padding_titel="
                                        isMobile && direccionVertical
                                            ? true
                                            : false
                                    "
                                    :placeholder_titel="
                                        mainElementParameters[
                                            'distancia_soportes'
                                        ].attribute.name
                                    "
                                    :style_edit_param="
                                        'margin-top: ' +
                                        margin_dropdowns +
                                        'px ;margin-bottom: ' +
                                        margin_dropdowns +
                                        'px;'
                                    "
                                    :style_inside_dropdown="
                                        'padding:4px !important; width: ' +
                                        width_params
                                    "
                                    :labelOverInput="true"
                                    @update:value="refreshParameters"
                                    @beforeUpdate:value="beforeUpdateParameter"
                                    @afterUpdate:value="afterUpdateParameter"
                                    :prop_title_show="true"
                                ></editParameterValueComponent>

                                <template v-if="mainElementParameters['opcion_compartimento']">
                                    <editParameterValueComponent
                                        ref="editParameterValueComponent"
                                        :parameter="
                                            mainElementParameters[
                                                'opcion_compartimento'
                                            ]
                                        "
                                        :value.sync="
                                            mainElementParameters[
                                                'opcion_compartimento'
                                            ].value
                                        "
                                        :no_margin_padding_titel="
                                            isMobile && direccionVertical
                                                ? true
                                                : false
                                        "
                                        :placeholder_titel="
                                            mainElementParameters[
                                                'opcion_compartimento'
                                            ].attribute.name
                                        "
                                        :style_edit_param="
                                            'margin-top: ' +
                                            margin_dropdowns +
                                            'px ;margin-bottom: ' +
                                            margin_dropdowns +
                                            'px;'
                                        "
                                        :style_inside_dropdown="
                                            'padding:4px !important; width: ' +
                                            width_params
                                        "
                                        :labelOverInput="true"
                                        @update:value="refreshParameters"
                                        @beforeUpdate:value="beforeUpdateParameter"
                                        @afterUpdate:value="afterUpdateParameter"
                                        :prop_title_show="true"
                                    ></editParameterValueComponent>
                                </template>

                                <!-- PARAMETROS IGUALES -->
                                <h6 class="font-weight-bold pt-2 d-block">{{ $t('s2_bandeja_escalera') }}</h6>

                                <editParameterValueComponent
                                    ref="editParameterValueComponent"
                                    :mainElement="mainElementParameters"
                                    :parameter="
                                        mainElementParameters['dimensiones']
                                    "
                                    :value.sync="
                                        mainElementParameters['dimensiones']
                                            .value
                                    "
                                    :no_margin_padding_titel="
                                        isMobile && direccionVertical
                                            ? true
                                            : false
                                    "
                                    :placeholder_titel="
                                        mainElementParameters['dimensiones']
                                            .attribute.name
                                    "
                                    :style_edit_param="
                                        'margin-top: ' +
                                        margin_dropdowns +
                                        'px ;margin-bottom: ' +
                                        margin_dropdowns +
                                        'px;'
                                    "
                                    :style_inside_dropdown="
                                        'padding:4px !important; width: ' +
                                        width_params
                                    "
                                    :labelOverInput="
                                        isMobile || direccionHorizontal
                                            ? true
                                            : false
                                    "
                                    @update:value="refreshParameters"
                                    @beforeUpdate:value="beforeUpdateParameter"
                                    @afterUpdate:value="afterUpdateParameter"
                                    :prop_title_show="false"
                                ></editParameterValueComponent>

                                <editParameterValueComponent
                                    ref="editParameterValueComponent"
                                    :mainElement="mainElementParameters"
                                    :parameter="
                                        mainElementParameters['opcion_tapa']
                                    "
                                    :value.sync="
                                        mainElementParameters['opcion_tapa']
                                            .value
                                    "
                                    :no_margin_padding_titel="
                                        isMobile && direccionVertical
                                            ? true
                                            : false
                                    "
                                    :placeholder_titel="
                                        mainElementParameters['opcion_tapa']
                                            .attribute.name
                                    "
                                    :style_edit_param="
                                        'margin-top: ' +
                                        margin_dropdowns +
                                        'px ;margin-bottom: ' +
                                        margin_dropdowns +
                                        'px;'
                                    "
                                    :style_inside_dropdown="
                                        'padding:4px !important; width: ' +
                                        width_params
                                    "
                                    :labelOverInput="
                                        isMobile || direccionHorizontal
                                            ? true
                                            : false
                                    "
                                    @update:value="refreshParameters"
                                    @beforeUpdate:value="beforeUpdateParameter"
                                    @afterUpdate:value="afterUpdateParameter"
                                    :prop_title_show="false"
                                ></editParameterValueComponent>
                            </div>

                            <!-- BUTTONS -->
                            <div
                                class="
                                    ml-5
                                    d-flex
                                    flex-column
                                    justify-content-center
                                    align-items-center
                                "
                            >
                                <!-- ------------- -->
                                <!-- EDIT BUTTON -->
                                <!-- ------------- -->
                                <button
                                    v-if="isMobile && !prop_readonly"
                                    class="btn btn-outline-dark btn_rounded"
                                    :class="
                                        isMobile
                                            ? 'btn_mobile_size'
                                            : 'btn_desktop_size'
                                    "
                                    style="z-index: 998"
                                    @click="showModalParameters(key)"
                                >
                                    <i class="fas fa-edit fa-sm"></i>
                                </button>

                                <!-- ------------- -->
                                <!-- REMOVE BUTTON -->
                                <!-- ------------- -->
                                <button
                                    v-if="!prop_readonly"
                                    v-visible="
                                        multiLevel.canRemoveElement(index + 1)
                                    "
                                    @click="
                                        removebandeja(key)
                                    "
                                    style="z-index: 998"
                                    :style="''"
                                    class="btn btn-outline-dark btn_rounded"
                                    :class="
                                        isMobile
                                            ? 'btn_mobile_size'
                                            : 'btn_desktop_size'
                                    "
                                >
                                    <i
                                        v-if="
                                            buttonsLoading[
                                                key + '_loading_remove'
                                            ]
                                        "
                                        class="fa fa-spinner fa-spin"
                                    ></i>
                                    <i v-else class="fas fa-minus fa-sm"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ------------- -->
                <!-- ADD BUTTON -->
                <!-- ------------- -->
                <button
                    v-if="!prop_readonly && helper.allowMultiple()"
                    @click="addBandeja()"
                    class="btn btn-outline-dark btn_rounded mt-5"
                    :class="isMobile ? 'btn_mobile_size' : 'btn_desktop_size'"
                >
                    <i v-if="buttonLoading" class="fa fa-spinner fa-spin"></i>
                    <i v-else class="fas fa-plus fa-sm"></i>
                </button>
            </div>
        </div>

        <!-- diagnostics -->
        <diagnostics-component v-if="!prop_readonly" />

        <!-- MODAL PARAMETERS -->
        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            ref="modal"
            v-if="elementSelected != null && !prop_readonly"
        >
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ $t("popup_parameters_small_screen_multilevel") }}
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-bs-dismiss="modal"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div
                        v-if="elementSelected"
                        class="
                            modal-body
                            d-flex
                            flex-column
                            align-items-center
                            justify-content-center
                        "
                    >
                        <!-- PARAMS -->
                        <main-element67-edit-parameters-component
                            :mainElement="elementSelected"
                            @change="refreshParametersAndSelectedElement"
                            @beforeUpdate="beforeUpdateParameter"
                            @afterUpdate="afterUpdateParameter"
                        />
                        <!-- IMATGE -->
                        <main-element67-images-component
                            :mainElement="elementSelected"
                            :inverted="false"
                        />
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                            data-dismiss="modal"
                        >
                            {{ $t("popup_cerrar_small_screen_multilevel") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.small-text {
    h6 {
        font-size: 14px !important;
        margin: 0 !important;
    }
    .form-control {
        font-size: 0.8rem !important;
        height: auto !important;
        padding: 1px !important;
        padding-left: 8px !important;
    }
    .pb-2 {
        padding-bottom: 0 !important;
    }
}
.modal-mobile {
    max-width: 100% !important;
    width: 100% !important;
    position: fixed !important;
    bottom: 0 !important;
}
.image_cursor_pointer {
    cursor: pointer;
}
.image_cursor_default {
    cursor: default;
}
.textParamFontSize {
    font-size: 95%;
}
.btn_mobile_size {
    width: 36px;
    height: 36px;
}
.btn_desktop_size {
    width: 42px;
    height: 42px;
}
.btn_rounded {
    padding: 8px;
}
.pos_params_vert {
    position: relative;
    left: 80px;
    width: 300px;
}
.pos_params_vert_mobile {
    position: relative;
    left: 0px;
    max-width: 300px;
}
.z_index_readonly {
    z-index: 500;
}
.z_index_no_readonly {
    z-index: -500;
}
</style>

<script>
// var VueScrollTo = require('vue-scrollto');
import VueScrollTo from "vue-scrollto";
import jQuery from "jquery";
import Vue from "vue";
import { app } from "../../application.js";
import Helper from "../../services/b66b67helper.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import mainElementsGenericComponent from "./mainElementsGeneric.vue";
import mainElement67EditParametersComponent from "./mainElement67EditParameters.vue";
import mainElement67ImagesComponent from "./mainElement67Images.vue";
import diagnosticsComponent from "../common/diagnostics.vue";

export default {
    extends: mainElementsGenericComponent,
    name: "mainElements67Component",
    data() {
        return {
            app: app,
            multiLevel: app.multiLevelHelper,
            helper: new Helper(app),
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            labelOverDropdown: true,
            bandejas: {},
            buttonLoading: false,
            buttonsLoading: [],
            solConstructiva: "",
            window: { width: 0, height: 0 },
            elementSelected: null,
            selectedElementKey: "",
        };
    },
    components: {
        editParameterValueComponent,
        mainElementsGenericComponent,
        mainElement67EditParametersComponent,
        mainElement67ImagesComponent,
        diagnosticsComponent
    },
    props: {
        prop_readonly: false
    },

    created() {
        this.solConstructiva = this.app.currentConfiguration.familyParameters[
            "sol_constructiva"
        ].value;

        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },

    computed: {
        topPositionTrapecio: function () {
            if (this.isMobile) {
                return this.topPositionTerra + 20;
            } else {
                return this.topPositionTerra + 20;

            }
        },
        stageActual: function () {
            return this.app.currentConfiguration.stage;
        },
        topPositionTextDimension: function () {

            if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual == 3 && !this.isMobile) return this.topPositionTerra + 30;//ok
            if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual == 4 && !this.isMobile) return this.topPositionTerra + 95;//ok
            if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual == 3 && this.isMobile) return this.topPositionTerra + 30;//ok
            if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual == 4 && this.isMobile) return this.topPositionTerra + 75;//ok

            if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual == 3 && this.isMobile) return this.topPositionTerra + 12;
            if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual == 4 && this.isMobile) return this.topPositionTerra + 40;
            if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual == 3 && !this.isMobile) return this.topPositionTerra + 12;
            if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual == 4 && !this.isMobile) return this.topPositionTerra + 70;

            if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared() && this.stageActual === 3) return this.topPositionTerra + 10;
            if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared() && this.stageActual === 4) return this.topPositionTerra + 10;

            if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return 10;//ok
            if (this.helper.isWall() && this.helper.withSoporteVertical()) return 10;//ok
            if (this.helper.isWall() && this.helper.fijadaDirectamente()) return 10;//ok


            if (this.helper.isCeiling() && this. helper.withSoporteTrapecio() && this.stageActual == 3)
                return this.topPositionTerra + 50;
            if (this.helper.isCeiling() && this. helper.withSoporteTrapecio() && this.stageActual == 4)
                return this.topPositionTerra + 105;

            if (this.helper.withSoportajeCliente() && this.stageActual === 3) return this.topPositionTerra - 30;//ok
            if (this.helper.withSoportajeCliente() && this.stageActual === 4) return this.topPositionTerra + 15;//ok
        },
        leftPositionTextDimension: function () {

            // wall
            if (this.helper.isWall() && this.solConstructiva.id === "10-p_sv" && this.stageActual === 3) return this.leftPositionTerra + 35;//ok
            if (this.helper.isWall() && this.solConstructiva.id === "10-p_sv" && this.stageActual === 4) return this.leftPositionTerra + 35;//ok
            if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return this.leftPositionTerra + 55;//ok
            if (this.helper.isWall() && this.helper.withPerfilDirectoAPared() && this.stageActual === 3) return this.leftPositionTerra + 55;//ok
            if (this.helper.isWall() && this.helper.withPerfilDirectoAPared() && this.stageActual === 4) return this.leftPositionTerra + 55;//ok
            if (this.helper.isWall() && this.helper.withSoporteVertical()) return this.leftPositionTerra + 55;//ok
            if (this.helper.isWall() && this.helper.fijadaDirectamente() && this.stageActual == 3) return this.leftPositionTerra + 35;//ok
            if (this.helper.isWall() && this.helper.fijadaDirectamente() && this.stageActual == 4) return this.leftPositionTerra + 40;//ok

            // floor
            if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual == 3 && this.isMobile) return this.leftPositionTerra + 65;//ok
            if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual == 4 && this.isMobile) return this.leftPositionTerra + 60;//ok
            if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual == 3 && !this.isMobile) return this.leftPositionTerra + 65;//ok
            if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual == 4 && !this.isMobile) return this.leftPositionTerra + 75;//ok

            if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual == 3) return this.leftPositionTerra + 60;//ok
            if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual == 4) return this.leftPositionTerra + 60;//ok

            // ceiling
            if (this.helper.isCeiling() && this. helper.withSoporteTrapecio() && this.stageActual == 3) return this.leftPositionTerra + 55;//ok
            if (this.helper.isCeiling() && this. helper.withSoporteTrapecio() && this.stageActual == 4) return this.leftPositionTerra + 60;//ok

            // cliente
            if (this.helper.withSoportajeCliente()) return this.leftPositionTerra + 60;//ok

            return 0;

        },
        showDeleteButton: function () {
            return (
                Object.keys(app.currentConfiguration.mainElementParameters)
                    .length > 1
            );
        },
        showMultilevel: function () {
            return false;
        },
        imgSize: function () {
            if (this.isMobile) {
                return 175;
            }
            return 200;
        },
        rotacioTerra: function () {
            if (this.helper.withSoportajeCliente()) return 0;
            if (this.helper.isWall()) return 0;
            if (this.helper.isFloor()) return -90;
            if (this.helper.isCeiling()) return 90;
            return 0;
        },
        rotacioBandeja: function () {
            if (this.helper.withSoportajeCliente()) return 0;
            if (this.helper.isWall() && this.helper.fijadaDirectamente()) return 90;
            if (this.helper.isWall() && this.helper.withSoporteVertical()) return 90;

            return 0;
        },
        leftPositionImageLeft: function () {
            //desktop
            if (!this.isMobile) {
                return 29;
                //mobile
            } else {
                return 25;
            }
        },
        leftPositionImageRight: function () {

            //mobile
            if (this.isMobile) {
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return -47;
                if (this.solConstructiva.id === "10-p_sv") return -37;

                //desktop
            } else {
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return - 57;
                if (this.solConstructiva.id === "10-p_sv") return - 37;
            }
            return 0;
        },
        leftPositionTerra: function () {

            if (this.isMobile) {
                if (this.solConstructiva.id === "10-p_sv") return 30;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return 20;
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return 42;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return 8;
                if (this.helper.isWall() && this.helper.withPerfil()) return 8;
            } else {
                if (this.solConstructiva.id === "10-p_sv") return 40;
                if (this.helper.fijadaDirectamente() && this.helper.isWall()) return 20;
                if (this.helper.fijadaDirectamente() && this.helper.isFloor()) return 0;
                if (this.helper.withSoporteSeparador() && this.helper.isFloor()) return +10;
                if (this.helper.fijadaDirectamente() && this.helper.isCeiling()) return -20;

                if (this.helper.isWall() && this.helper.withPerfil() && this.helper.withSoporteHorizontal()) return 9;

                if (this.helper.isWall() && this.helper.withSoporteVertical()) return 48;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return 10;
            }

            return 0;
        },
        topPositionTerra: function () {

            if (this.isMobile) {
                if (this.helper.withSoporteSeparador() && this.helper.isFloor()) return -25;
                if (this.helper.fijadaDirectamente() && this.helper.isFloor()) return -30;

                if (this.helper.isCeiling() && this.helper.withPerfil()) return -17;
                if (this.helper.withSoporteTrapecio()) return -17;
                if (this.helper.withSoporteSeparador()) return -59;

                //desktop
            } else {

                if (this.helper.withSoporteSeparador() && this.helper.isFloor()) return - 35;
                if (this.helper.fijadaDirectamente() && this.helper.isFloor()) return -45;

                if (this.helper.fijadaDirectamente() && this.helper.isWall()) return 0;
                if (this.helper.fijadaDirectamente() && this.helper.isCeiling()) return 0;

                if (this.helper.isCeiling() && this.helper.withPerfil()) return -19;
                if (this.helper.isCeiling() && this.helper.withSoporteTrapecio()) return + 20;
            }
            return 0;
        },
        topPositionBandejaTapaTabiques: function () {

            if (this.isMobile) {
                if (this. helper.withSoporteTrapecio()) {
                    return 75;
                } else if (this.helper.isFloor() && this.helper.fijadaDirectamente()) {
                    return this.topPositionTerra + 67;
                } else if (this.helper.isWall() && this.helper.fijadaDirectamente()) {
                    return 0;
                } else if (this.helper.isFloor() && this.helper.withSoporteSeparador()) {
                    return this.topPositionTerra + 50;
                } else if (!this.helper.isFloor() && this.helper.withSoporteSeparador()) {
                    return 50;
                } else {
                    return 0;
                }

                //desktop
            } else {

                if (this. helper.withSoporteTrapecio()) {
                    return 126;
                } else if (this.helper.isFloor() && this.helper.fijadaDirectamente()) {
                    return this.topPositionTerra + 77;
                } else if (this.helper.isFloor() && this.helper.withSoporteSeparador()) {
                    return this.topPositionTerra + 58;

                } else { return 0; }
            }
            return 0;
        },
        direccionHorizontal: function () {
            if (this.isMobile) return false;

            if (this.helper.isFloor() && this.growDown) return false;

            if (
                this.solConstructiva.id.includes("-h") &&
                !this.solConstructiva.id === "10-p_sh_dir-h"
            )
                return true;

            if (
                this.solConstructiva.id === "10-s_dir" ||
                this.solConstructiva.id === "10-s_sep"
            )
                return true;

            return false;
        },
        direccionVertical: function () {
            if (this.solConstructiva.id.includes("-v")) return true;
            if (this.solConstructiva.id === "10-t_tra") return true;
            if (this.solConstructiva.id === "10-p_dir") return true; //ok
            if (this.solConstructiva.id === "10-p_sv") return true; //ok
            if (this.solConstructiva.id === "10-t_sop") return true;
            if (this.solConstructiva.id === "10-p_sh_dir-h") return true;
            if (this.solConstructiva.id === "10-p_sh_per-h") return true;
            if (this.solConstructiva.id === "10-s_dir" && this.isMobile)
                return true;
            if (this.solConstructiva.id === "10-cliente") return true;

            return false;
        },
        growRight: function () {
            if (this.isMobile) {
                return false;
            } else {
                if (
                    this.direccionHorizontal &&
                    this.solConstructiva.id === "10-t_tra"
                )
                    return true;
                if (this.helper.fijadaDirectamente() && this.helper.isFloor()) return true;
                if (this.helper.withSoporteSeparador() && this.helper.isFloor()) return true;
            }

            return false;
        },
        growLeft: function () {
            //no posar res aqui
            if (this.direccionHorizontal && !this.growRight) return true;
            return false;
        },
        growUp: function () {
            return false;
        },
        growDown: function () {

            if (Object.keys(this.app.currentConfiguration.mainElementParameters).length > 3) return true;

            if (this.direccionVertical && this.solConstructiva.id === "10-p_sv") return true;
            if (this.solConstructiva.id === "10-p_dir") return true;
            if (this.solConstructiva.id === "10-t_sop") return true;
            if (this.solConstructiva.id === "10-t_tra") return true;
            if (this.solConstructiva.id === "10-p_sh_dir-h") return true;
            if (this.solConstructiva.id === "10-p_sh_dir-v") return true;
            if (this.solConstructiva.id === "10-p_sh_per-h") return true;
            if (this.solConstructiva.id === "10-p_sh_per-v") return true;
            if (this.solConstructiva.id === "10-cliente") return true;
            if (this.solConstructiva.id === "10-s_dir" && this.isMobile) return true;
            if (this.solConstructiva.id === "10-s_sep" && this.isMobile) return true;

            return false;
        },
        leftPositionAddButton: function () {
            let numElements = Object.keys(
                this.app.currentConfiguration.mainElementParameters
            ).length;

            if (this.isMobile) {
                if (this.helper.withSoportajeCliente()) return 110;

                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return -2;
                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return 0;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return this.leftPositionTerra - 10;
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return this.leftPositionTerra - 12;

                if (this.helper.isCeiling() && this.growDown && this.helper.fijadaDirectamente()) return this.leftPositionTerra - 15;
                if (this.helper.isFloor() && this.growDown && this.helper.fijadaDirectamente()) return this.leftPositionTerra + 78;

                if (this.growDown && this.helper.withSoporteSeparador()) return this.leftPositionTerra + 75;
                if (this.growDown && this.helper.withSoporteVertical()) return this.leftPositionTerra + 80;

                if (this.helper.isCeiling() && this. helper.withSoporteTrapecio()) return 80;

                return this.leftPositionTerra + 30;

            } else {

                if (this.helper.withSoportajeCliente()) return 115;

                if (this.helper.isFloor() && this.growDown && this.helper.fijadaDirectamente()) return this.leftPositionTerra + 90;
                if (this.helper.isFloor() && this.growDown && this.helper.withSoporteSeparador()) return this.leftPositionTerra + 80;
                if (this.helper.isFloor() && !this.growDown) return numElements * 200 + 20;

                if (this.solConstructiva.id === "10-p_sv") return this.leftPositionTerra - 10;

                if (this.growDown && this.helper.withSoporteVertical()) return this.leftPositionTerra + 80;

                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return -5;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return -3;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return this.leftPositionTerra - 12;


                if (this.helper.isCeiling() && this. helper.withSoporteTrapecio()) return 90;
                if (this.helper.isCeiling()) return 75;

            }
            return 0;
        },
        topPositionAddButton: function () {
            let numElements = Object.keys(
                this.app.currentConfiguration.mainElementParameters
            ).length;

            if (this.isMobile) {
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return numElements * this.imgSize + 10;
                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return numElements * this.imgSize + 15;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return numElements * this.imgSize + 10;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return numElements * this.imgSize + 10;

                if (this.helper.withSoportajeCliente()) return numElements * this.imgSize - 65;

                if (this.helper.isFloor() && this.growDown && this.helper.withSoporteSeparador())
                    return numElements * this.imgSize + + this.topPositionTerra + 20;
                if (!this.helper.isFloor() && this.growDown && this.helper.withSoporteSeparador())
                    return numElements * this.imgSize + 20;

                if (this.growDown && this.helper.withPerfil()) return numElements * this.imgSize + 10;
                if (this.growDown && this.helper.withSoporteTrapecio()) return numElements * this.imgSize + 10;

                if (this.helper.isFloor() && !this.growDown && this.helper.fijadaDirectamente()) return numElements * this.imgSize - 40;
                if (this.helper.isFloor() && this.growDown && this.helper.fijadaDirectamente()) return numElements * this.imgSize + + this.topPositionTerra + 20;


                return numElements * this.imgSize - 20;

            } else {

                if (this.helper.withSoportajeCliente()) return numElements * this.imgSize - 70;

                if (this.helper.isFloor() && !this.growDown) return this.topPositionTerra + 170;
                // if (this.helper.isFloor() && this.growDown && ) return numElements * this.imgSize - 30;
                // if (this.helper.isFloor() && this.growDown) return numElements * this.imgSize - 30;

                if (this.helper.isFloor() && this.growDown && this.helper.fijadaDirectamente()) return numElements * this.imgSize - 30;
                if (this.helper.isFloor() && this.growDown && this.helper.withSoporteSeparador()) return numElements * this.imgSize - 10;

                if (this.solConstructiva.id === "10-p_sv") return numElements * 200 + 10;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return numElements * this.imgSize + 10;
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return numElements * this.imgSize - 10;
                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return numElements * this.imgSize + 10;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return numElements * 200 + 10;

                if (this.growUp) return 0;

                if (this.growDown && !this.helper.withSoportajeCliente()) return numElements * 200 + 20;

                if (this.growRight) return 100;
                if (this.growLeft) return 0;
            }
            return 0;
        },
        topPositionEditButton: function () {
            if (this.isMobile) {
                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return this.topPositionTerra + 50;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return this.topPositionTerra + 50;
                if (this.helper.isWall() && this.helper.withSoporteHorizontal()) return this.topPositionTerra + 30;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return this.topPositionTerra + 60;
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return this.topPositionTerra + 55;

                if (this.helper.isFloor() && this.helper.fijadaDirectamente()) return this.topPositionTerra + 60;
                if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual === 3) return this.topPositionTerra + 40;
                if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual === 4) return this.topPositionTerra + 50;

                if (this.helper.isCeiling() && this.helper.withPerfil() && this.helper.withSoporteHorizontal()) return this.topPositionTerra + 110;
                if (this.helper.isCeiling() && this.helper.withSoporteTrapecio()) return this.topPositionTerra + 80;

                if (this.helper.withSoportajeCliente()) return this.topPositionTerra - 5;


            }
        },
        leftPositionEditButton: function () {
            let numElements = Object.keys(
                this.app.currentConfiguration.mainElementParameters
            ).length;

            if (this.isMobile) {
                if (this.solConstructiva.id === "10-p_sv")
                    return this.leftPositionTerra + 90;

                if (this.helper.withSoportajeCliente()) return 50;

                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return 180;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return 180;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return this.leftPositionTerra + 90;
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return this.leftPositionTerra + 100;

                if (this.helper.isFloor() && this.helper.withSoporteTrapecio()) return this.leftPositionTerra + 40;
                if (this.helper.isFloor() && this.helper.fijadaDirectamente()) return this.leftPositionTerra + 55;
                if (this.helper.isFloor() && this.growDown && this.helper.fijadaDirectamente()) return this.leftPositionTerra + 78;
                if (this.helper.isFloor() && this.helper.withSoporteSeparador()) return this.leftPositionTerra + 60;

                if (this.growDown && this.helper.withSoporteVertical()) return this.leftPositionTerra + 80;

                if (this.helper.isCeiling() && this. helper.withSoporteTrapecio()) return this.leftPositionTerra + 55;
                if (this.helper.isCeiling() && this.growDown && this.helper.fijadaDirectamente()) return this.leftPositionTerra - 15;

                return this.leftPositionTerra + 30;
            }
            return 0;
        },
        leftPositionRemoveButton: function () {
            if (this.isMobile) {
                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return 180;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return 180;
                if (this.helper.isWall() && this.helper.withSoporteHorizontal()) return 60;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return 110;
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return 120;

                if (this.helper.isFloor() && this.helper.fijadaDirectamente()) return 100;
                if (this.helper.isFloor() && this.helper.withSoporteSeparador()) return 100;

                if (this.helper.isCeiling() && this.helper.withPerfil() && this.helper.withSoporteHorizontal()) return 110;
                if (this.helper.isCeiling() && this.helper.withSoporteTrapecio()) return 100;

                if (this.helper.withSoportajeCliente()) return 110;

            } else {
                return 200;
            }

            return 0;
        },
        topPositionRemoveButton: function () {
            if (this.isMobile) {
                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return 100;
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return 100;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return 105;
                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return 135;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return 95;

                if (this.helper.isFloor() && this.helper.fijadaDirectamente()) return this.topPositionTerra + 60;

                if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual === 3) return this.topPositionTerra + 40;
                if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual === 4) return -10;

                if (this.helper.isCeiling() && this.withPerfil && this.helper.withSoporteHorizontal()) return 25;
                if (this.helper.isCeiling() && this.helper.withSoporteTrapecio()) return this.topPositionTerra + 80;

                if (this.helper.withSoportajeCliente()) return this.topPositionTerra - 5;

                // desktop
            } else {

                if (this.solConstructiva.id === "10-p_sv") return 90;
                if (this.helper.withSoportajeCliente()) return 130;

                if (this.helper.isWall() && this.helper.withPerfilDirectoAPared()) return 90;
                if (this.helper.isWall() && this.helper.withSoporteHorizontalDirectoPared()) return 90;
                if (this.helper.isWall() && this.helper.fijadaDirectamente()) return 90;
                if (this.helper.isWall() && this.helper.withSoporteVertical()) return 190;

                if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual === 3) return this.topPositionTerra + 70;
                if (this.helper.isFloor() && this.helper.fijadaDirectamente() && this.stageActual === 4) return this.topPositionTerra + 30;
                if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual === 3) return + 10;
                if (this.helper.isFloor() && this.helper.withSoporteSeparador() && this.stageActual === 4) return + 10;
                if (this.helper.isFloor() && !this.isMultinivell) return -20;

                if (this.helper.isCeiling() && this.helper.withPerfil() && this.helper.withSoporteHorizontal()) return 135;
                if (this.helper.isCeiling() && this. helper.withSoporteTrapecio()) return 80;
            }
            return 0;
        },
        isMobile: function () {
            let a = this.window.width < 750;
            return a;
        },
        isMobile_xs: function () {
            let a = this.window.width < 350;
            return a;
        },
        isMobile_lg: function () {
            let a = this.window.width > 500 && this.isMobile;
            return a;
        },
        isTablet: function () {
            let a = this.window.width < 800;
            return a;
        },
        width_params: function () {
            if (this.isMobile) {
                return "200px";
            } else if (this.direccionHorizontal) {
                return "160px";
            } else {
                return "160px";
            }
        },
        margin_dropdowns: function () {
            if (this.isMobile && this.direccionVertical) {
                return 2;
            } else {
                return 0;
            }
        },
        //wallrotation
    },

    methods: {

        scrollToElement: function (id) {
            VueScrollTo.scrollTo('#' + id, 300, { container: 'body' });
        },
        refreshParametersAndSelectedElement: async function () {

            await this.app.asyncProcess(false, false);
            this.refreshElementSelected();
        },
        refreshElementSelected: function () {

            if (this.selectedElementKey) {
                this.elementSelected = Object.keys(
                    this.app.currentConfiguration.mainElementParameters
                )
                    .filter((key) => key === this.selectedElementKey)
                    .reduce((obj, key) => {
                        // obj[key] = this.app.currentConfiguration.mainElementParameters[key];
                        // return obj;
                        return this.app.currentConfiguration
                            .mainElementParameters[key];
                    }, {});

            }
        },

        /**
         * Binds events to Helper
         */
        beforeUpdateParameter: async function (param, value, oldValue, mainElement) {
            await this.helper.beforeUpdateParameter(param, value, mainElement)
        },
        afterUpdateParameter: async function (param, value, oldValue, mainElement) {
            await this.helper.afterUpdateParameter(param, value, mainElement)
        },

        showModalParameters: function (selectedElementKey) {
            this.selectedElementKey = selectedElementKey;
            //console.log("this.selectedElementKey:", this.selectedElementKey);

            this.refreshElementSelected();

            // Wait till dom update
            this.$nextTick(() => {
                let modal = this.$refs.modal;
                jQuery(modal).modal("show");
            });
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },

        refreshParameters: async function () {
            await this.app.asyncProcess(false, false);
        },

        mostrarTapa_inferior: function (mainElementParameters) {
            if (
                mainElementParameters["opcion_tapa"].value == "" ||
                mainElementParameters["opcion_tapa"].value.id == "n"
            ) {
                // Ocultar imagen Tapa si no hay nada seleccionado
                // o se ha seleccionado sin tapa
                return false;
            } else if (mainElementParameters["opcion_tapa"].value.id == "2s") {
                // Mostrar imagen Tapa solo si ha seleccionado con dos tapas
                return true;
            }
            return false;
        },

        mostrarTapa_superior: function (mainElementParameters) {
            if (
                mainElementParameters["opcion_tapa"].value == "" ||
                mainElementParameters["opcion_tapa"].value.id == "n"
            ) {
                // Ocultar imagen Tapa si no hay nada seleccionado
                // o se ha seleccionado sin tapa
                return false;
            } else if (mainElementParameters["opcion_tapa"].value.id == "s") {
                // Mostrar imagen Tapa superior si hay seleccionado con tapa
                return true;
            } else if (mainElementParameters["opcion_tapa"].value.id == "2s") {
                // Mostrar imagen Tapa superior si hay seleccionado con dos tapas
                return true;
            }
            return false;
        },
        mostrarCompartimento: function (
            mainElementParameters,
            numCompartimentos
        ) {
            var numeroCompartimentosSeleccionados = 0;

            if (mainElementParameters["opcion_compartimento"].value == "") {
                // Ocultar imagen Tapa si no hay nada seleccionado
                // o se ha seleccionado sin tapa
                return false;
            } else {
                numeroCompartimentosSeleccionados =
                    mainElementParameters["opcion_compartimento"].value
                        .num_value;
                if (numCompartimentos == numeroCompartimentosSeleccionados) {
                    return true;
                }
            }

            return false;
        },

        addBandeja: async function (key) {

            this.buttonLoading = true
            let nomBandejaACrear = Object.keys(this.app.currentConfiguration.mainElementParameters).length + 1;

            await this.helper.resetDistanciaSoportes();
            await this.multiLevel.addElement(nomBandejaACrear);
            await this.helper.showCurrentDistanciaSoportes();

            this.buttonLoading = false
        },

        removebandeja: async function (keyBandejaABorrar, key_remove_loading) {
            var self = this;

            this.$nextTick(async () => {
                self.multiLevel.removeElementByKey(keyBandejaABorrar)
            })

            this.$forceUpdate()

            await this.helper.resetDistanciaSoportes();
            await app.asyncProcess(false, false);
            await this.helper.showCurrentDistanciaSoportes();

            return

            var self = this;

            //console.log('key_remove_loading: ', key_remove_loading);

            Vue.set(this.buttonsLoading, key_remove_loading, 1);

            //------------------------------------------------------------------------------------
            //espera que Vue vacie la cola asincrónica de actualizaciones del DOM para realizar actualizaciones de DOM -> eliminar bandeja
            //------------------------------------------------------------------------------------
            this.$nextTick(async () => {

                delete self.app.currentConfiguration.mainElementParameters[
                    keyBandejaABorrar
                ];

                self.bandejas = self.app.currentConfiguration.mainElementParameters;

                self.renombraBandejas();

                await this.helper.resetDistanciaSoportes();
                await app.asyncProcess(false, false);

                Vue.set(self.buttonsLoading, key_remove_loading, 0);

            });
            //------------------------------------------------------------------------------------

        },
        renombraBandejas: function () {
            let newKey = 0;
            Object.entries(
                this.app.currentConfiguration.mainElementParameters
            ).forEach(([key, value]) => {
                newKey += 1;
                if (
                    this.app.currentConfiguration.mainElementParameters.hasOwnProperty(
                        key
                    )
                ) {
                    delete this.app.currentConfiguration.mainElementParameters[
                        key
                    ];
                    this.app.currentConfiguration.mainElementParameters[
                        newKey
                    ] = value;
                }
            });
        },
    },
    beforeMount() {
        this.bandejas = app.currentConfiguration.mainElementParameters;
    },
    mounted() {
        this.$emit("ishorizontal", this.direccionHorizontal);
    },
};
</script>

